import { useState } from "react";
import { Truck, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const CARRIERS = ["UPS", "FedEx", "USPS", "DHL", "Other"];

export default function DispatchForm({ orderId, onSubmit, onCancel }) {
  const [carrier, setCarrier] = useState("UPS");
  const [num, setNum] = useState("");
  const [url, setUrl] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await onSubmit({ carrier, tracking_number: num.trim(), tracking_url: url.trim(), note: note.trim() });
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Could not mark dispatched");
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="border border-sky-200 bg-sky-50 p-3 space-y-2 min-w-[260px]" data-testid={`dispatch-form-${orderId}`}>
      <p className="flex items-center gap-1.5 font-tech text-[10px] uppercase tracking-[0.16em] text-sky-800"><Truck className="h-3.5 w-3.5" /> Dispatch & email tracking</p>
      <div className="flex gap-2">
        <select value={carrier} onChange={(e) => setCarrier(e.target.value)} data-testid={`dispatch-carrier-${orderId}`}
          className="font-tech text-xs border border-slate-300 bg-white px-2 py-1.5 rounded-sm">
          {CARRIERS.map((c) => <option key={c}>{c}</option>)}
        </select>
        <Input value={num} onChange={(e) => setNum(e.target.value)} placeholder="Tracking number *" required data-testid={`dispatch-tracking-${orderId}`} className="h-8 text-xs rounded-sm bg-white" />
      </div>
      {carrier === "Other" && <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="Tracking URL" data-testid={`dispatch-url-${orderId}`} className="h-8 text-xs rounded-sm bg-white" />}
      <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note to customer (optional)" data-testid={`dispatch-note-${orderId}`} className="h-8 text-xs rounded-sm bg-white" />
      {err && <p className="text-xs text-red-600" data-testid={`dispatch-error-${orderId}`}>{err}</p>}
      <div className="flex gap-2 justify-end">
        <Button type="button" size="sm" variant="ghost" onClick={onCancel} data-testid={`dispatch-cancel-${orderId}`}>Cancel</Button>
        <Button type="submit" size="sm" disabled={busy || !num.trim()} data-testid={`dispatch-submit-${orderId}`}>
          {busy && <Loader2 className="h-3 w-3 animate-spin" />} Dispatch & notify
        </Button>
      </div>
    </form>
  );
}
